import { GdsServiceProductStatus, OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { getTotalPrice } from '../../../utils';
import { getActualProduct, getBaggageName } from '../../../ServiceSummary/utils';
export function baggageOptionItemFactory({ key, travellerId, count, confirmedCount, segmentsCount, gdsService, products = [], groupType }) {
    var _a;
    let name;
    let resultCount;
    let price;
    let included = confirmedCount === count;
    const serviceId = gdsService.id;
    switch (groupType) {
        case 'all':
            resultCount = count;
            price = getTotalPrice(products, product => product.price);
            name = getBaggageName(gdsService, count);
            if (key === 'allSegments') {
                price.amount *= segmentsCount;
            }
            break;
        case 'booked':
            resultCount = count - confirmedCount;
            price = getTotalPrice(products.filter(product => product.status === GdsServiceProductStatus.Booked), product => product.price);
            name = getBaggageName(gdsService, count - confirmedCount);
            break;
        case 'confirmed':
            resultCount = confirmedCount;
            name = getBaggageName(gdsService, confirmedCount);
            price = getTotalPrice(products.filter(product => product.status === GdsServiceProductStatus.Ticketed), product => product.price);
            included = true;
            break;
    }
    const dCount = count - confirmedCount;
    return {
        id: serviceId,
        segment: key,
        count: resultCount,
        name: name,
        price: price,
        included: included,
        status: (_a = getActualProduct(products)) === null || _a === void 0 ? void 0 : _a.status,
        iconName: gdsService.baggageType,
        deleteMeta: groupType !== 'confirmed'
            ? {
                serviceId: serviceId,
                passengerId: travellerId,
                segmentId: key,
                count: count - dCount,
                allowedSegments: gdsService.allowedSegments,
                type: OrderAdditionalServiceGdsServiceServiceType.Baggage,
                allSegments: key === 'allSegments'
            }
            : null
    };
}
